<template>
  <h3 class="title_h3">
    <slot />
  </h3>
</template>


